<template lang="pug">
  div(v-if="isPickupHouse" :class="customClasses ? '' : 'mt-ds-sm lg:mt-ds-md'")
    VeeField(
      name="pickupPropertyType"
      v-slot="{ field, errors }"
    )
      SelRefined(
        v-bind="field"
        :value="getPickupPropertyType"
        @input="handlePropertyType"
        :options="getPropertyTypesHouse"
        option-text="name"
        option-value="value"
        :placeholder="$t('location_form.select_property_type')"
        :custom-classes="!errors.length && isPickupFlat ? '!rounded-b-none ' + customClasses : customClasses"
        :initial-open="true"
        :sub-menu="true"
        indicator
        qa-tag="sel_pickup_prop_type_house"
      )
      VeeErrorMessage(name="pickupPropertyType")
        TextInputError(class="my-ds-sm")
          | {{ $t('location_form.error.property_type_from') }}
  div(v-else-if="isPickupFlat" :class="customClasses ? '' : 'mt-ds-sm lg:mt-ds-md'")
    VeeField(
      name="pickupPropertyType"
      v-slot="{ field, errors }"
    )
      SelRefined(
        v-bind="field"
        :value="getPickupPropertyType"
        @input="handlePropertyType"
        :options="getPropertyTypesFlat"
        option-text="name"
        option-value="value"
        :custom-classes="!errors.length && !propertyFloorHidden && requiresPickupFloor ? '!rounded-b-none ' + customClasses : customClasses"
        :placeholder="$t('location_form.select_property_type')"
        :initial-open="true"
        :sub-menu="true"
        indicator
        qa-tag="sel_pickup_prop_type_flat"
      )
      VeeErrorMessage(name="pickupPropertyType")
        TextInputError(class="my-ds-sm")
          | {{ $t('location_form.error.property_type_from') }}

      SelRefined(
        v-if="!propertyFloorHidden && requiresPickupFloor"
        :value="getPickupFloor"
        @input="handlePickupFloor"
        :class="!errors.length ? '' : 'mt-ds-sm lg:mt-ds-md'"
        :custom-classes="!errors.length ? '!rounded-t-none !border-t-0 ' + floorStylingToConnectLiftAvailable : floorStylingToConnectLiftAvailable"
        :options="getFloors"
        option-text="name"
        option-value="value"
        indicator
        qa-tag="sel_pickup_floor")

    VeeField(
      v-if="requiresPickupFloor && isPickupGroundFloor && isFrenchLocale"
      name="pickupLiftSize"
      v-slot="{ field, errors }"
    )
      SelRefined(
        v-bind="field"
        :value="liftSizeValue"
        @input="handleLiftSize"
        custom-classes="!rounded-t-none !border-t-0"
        :options="getLiftSizeOptions"
        option-text="name"
        option-value="value"
        :placeholder="$t('location_form.lift_size')"
        indicator
        qa-tag="sel_pickup_lift_size")
      VeeErrorMessage(name="pickupLiftSize")
        TextInputError(class="my-ds-sm")
          | {{ $t('location_form.error.lift_size') }}

    SelRefined(
      v-if="requiresPickupFloor && isPickupGroundFloor && !isFrenchLocale"
      :value="liftAvailable"
      @input="handleLiftAvailable"
      :custom-classes="'!rounded-t-none !border-t-0'"
      :options="getLiftAvailableOptions"
      option-text="name"
      option-value="value"
      indicator
      qa-tag="sel_pickup_lift")

  div(v-else-if="!propertyTypeHidden" :class="customClasses ? '' : 'mt-ds-sm lg:mt-ds-md'")
    VeeField(
      name="pickupPropertyType"
      v-slot="{ field, errors }"
    )
      SelRefined(
        v-bind="field"
        :value="getPickupPropertyType"
        @input="handlePropertyType"
        :options="getPropertyTypesMain"
        option-text="name"
        option-value="value"
        :custom-classes="!errors.length && !propertyFloorHidden && requiresPickupFloor ? '!rounded-b-none ' + customClasses : customClasses"
        :placeholder="$t('location_form.select_property_type')"
        :initial-open="getPickupPropertyType === ''"
        indicator
        qa-tag="sel_pickup_prop_type")
      VeeErrorMessage(name="pickupPropertyType")
        TextInputError(class="my-ds-sm")
          | {{ $t('location_form.error.property_type_from') }}

      SelRefined(
        v-if="!propertyFloorHidden && requiresPickupFloor"
        :value="getPickupFloor"
        @input="handlePickupFloor"
        :class="!errors.length ? '' : 'mt-ds-sm lg:mt-ds-md'"
        :custom-classes="!errors.length ? '!rounded-t-none !border-t-0 ' + floorStylingToConnectLiftAvailable : floorStylingToConnectLiftAvailable"
        :options="getFloors"
        option-text="name"
        option-value="value"
        indicator
        qa-tag="sel_pickup_floor")

    VeeField(
      v-if="requiresPickupFloor && isPickupGroundFloor && isFrenchLocale"
      name="pickupLiftSize"
      v-slot="{ field, errors }"
    )
      SelRefined(
        v-bind="field"
        :value="liftSizeValue"
        @input="handleLiftSize"
        custom-classes="!rounded-t-none !border-t-0"
        :options="getLiftSizeOptions"
        option-text="name"
        option-value="value"
        :placeholder="$t('location_form.lift_size')"
        indicator
        qa-tag="sel_pickup_lift_size")
      VeeErrorMessage(name="pickupLiftSize")
        TextInputError(class="my-ds-sm")
          | {{ $t('location_form.error.lift_size') }}

    SelRefined(
      v-if="requiresPickupFloor && isPickupGroundFloor && !isFrenchLocale"
      :value="liftAvailable"
      @input="handleLiftAvailable"
      :custom-classes="'!rounded-t-none !border-t-0'"
      :options="getLiftAvailableOptions"
      option-text="name"
      option-value="value"
      indicator
      qa-tag="sel_pickup_lift")
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mapGetters, mapActions } from "vuex"
import { getAttributes } from "~/utils/block"
import {
  SET_PICKUP_PROPERTY_TYPE,
  SET_LISTING,
  SET_PICKUP_FLOOR,
  SET_PICKUP_LIFT_AVAILABLE,
  SET_PICKUP_LIFT_TYPE,
  GET_PICKUP_FLOOR,
  GET_PICKUP_PROPERTY_TYPE,
  GET_PICKUP_LIFT_AVAILABLE,
  GET_PICKUP_LIFT_TYPE,
  state as InitialListing
} from "~/store/listing"
import { isHouse, isFlat, requiresFloor } from "~/services/public/Listing"
import {
  FLOOR_GROUND,
  LIFT_AVAILABLE,
  LIFT_UNAVAILABLE,
  LIFT_TYPE_NO_LIFT,
  LIFT_TYPE_STANDARD,
  LIFT_TYPE_LARGE,
  LIFT_TYPE_EXTRA_LARGE
} from "~/constants/listing"
import {
  GET_FLOORS,
  GET_PROPERTY_TYPES,
  GET_PROPERTY_TYPES_MAIN,
  GET_PROPERTY_TYPES_FLAT,
  GET_PROPERTY_TYPES_HOUSE
} from "~/store/property"
import { swapFirstTwoElements } from "~/scripts/useful-functions"
import { LOCALE } from "~/constants/locale"

export default defineComponent({
  name: "PropertyPickupInput",

  props: {
    propertyTypeHidden: {
      type: Boolean
    },
    propertyFloorHidden: {
      type: Boolean
    },
    block: {
      type: Object as () => Block,
      required: true
    },
    virgin: {
      type: Boolean
    },
    lazy: {
      type: Boolean,
      default: true
    },
    customClasses: {
      type: String,
      default: ""
    }
  },

  computed: {
    ...mapGetters("listing", {
      getPickupPropertyType: GET_PICKUP_PROPERTY_TYPE,
      getPickupFloor: GET_PICKUP_FLOOR,
      getPickupLiftAvailable: GET_PICKUP_LIFT_AVAILABLE,
      getPickupLiftType: GET_PICKUP_LIFT_TYPE
    }),
    ...mapGetters("property", {
      getStorePropertyTypes: GET_PROPERTY_TYPES,
      getStorePropertyTypesMain: GET_PROPERTY_TYPES_MAIN,
      getPropertyTypesHouse: GET_PROPERTY_TYPES_HOUSE,
      getPropertyTypesFlat: GET_PROPERTY_TYPES_FLAT,
      getFloors: GET_FLOORS
    }),

    getPropertyTypesMain(): any[] {
      if (!this.getStorePropertyTypesMain) return []

      const propertyTypesToShow = this.getStorePropertyTypesMain.filter(type => !type.hidden)

      if (this.$i18n.locale === LOCALE.ES) {
        return swapFirstTwoElements(propertyTypesToShow)
      }
      return propertyTypesToShow
    },

    attributes(): any {
      return this.virgin ? null : getAttributes(this.block)
    },

    liftAvailable(): number {
      if (this.getPickupLiftAvailable === null) {
        this.setLiftAvailable(LIFT_AVAILABLE)
        return LIFT_AVAILABLE
      }
      return this.getPickupLiftAvailable
    },

    getLiftAvailableOptions(): LiftOption[] {
      return [
        {
          name: this.$t("location_form.lift_available"),
          value: LIFT_AVAILABLE
        },
        {
          name: this.$t("location_form.lift_not_available"),
          value: LIFT_UNAVAILABLE
        }
      ]
    },
    getLiftSizeOptions(): LiftSizeOption[] {
      return [
        {
          name: this.$t("location_form.lift_no_lift") as string,
          value: LIFT_TYPE_NO_LIFT
        },
        {
          name: this.$t("location_form.lift_small") as string,
          value: LIFT_TYPE_STANDARD
        },
        {
          name: this.$t("location_form.lift_medium") as string,
          value: LIFT_TYPE_LARGE
        },
        {
          name: this.$t("location_form.lift_large") as string,
          value: LIFT_TYPE_EXTRA_LARGE
        }
      ]
    },
    liftSizeValue(): string | null {
      if (this.getPickupLiftAvailable === LIFT_UNAVAILABLE) {
        return LIFT_TYPE_NO_LIFT
      }
      if (this.getPickupLiftAvailable === LIFT_AVAILABLE && this.getPickupLiftType) {
        return this.getPickupLiftType
      }
      return null;
    },
    isFrenchLocale(): boolean {
      return this.$i18n.locale === LOCALE.FR
    },
    isPickupGroundFloor(): boolean {
      return this.getPickupFloor === FLOOR_GROUND
    },
    isPickupHouse(): boolean {
      return isHouse(this.getPickupPropertyType)
    },
    isPickupFlat(): boolean {
      return isFlat(this.getPickupPropertyType)
    },
    requiresPickupFloor(): boolean {
      return requiresFloor(this.getPickupPropertyType, this.propertyTypeHidden, this.propertyFloorHidden, this.getStorePropertyTypes)
    },
    floorStylingToConnectLiftAvailable(): string {
      return this.isPickupGroundFloor ? '!rounded-b-none' : ''
    }
  },

  created() {
    this.setListing(InitialListing())
  },

  methods: {
    ...mapActions("listing", {
      setPickupFloor: SET_PICKUP_FLOOR,
      setListing: SET_LISTING,
      setPickupPropertyType: SET_PICKUP_PROPERTY_TYPE,
      setLiftAvailable: SET_PICKUP_LIFT_AVAILABLE,
      setLiftType: SET_PICKUP_LIFT_TYPE
    }),

    handlePropertyType(value: string) {
      if (!isFlat(value as string) || this.getPickupFloor === FLOOR_GROUND) {
        this.setPickupFloor(FLOOR_GROUND)
        this.setLiftAvailable(null)
        this.setLiftType(null)
      }
      this.setPickupPropertyType(value)
    },

    handlePickupFloor(value: string | null): void {
      if (value === FLOOR_GROUND) {
        this.setLiftAvailable(null)
        this.setLiftType(null)
      }
      this.setPickupFloor(value)
    },

    handleLiftAvailable(value: string | null): void {
      this.setLiftAvailable(value)
    },

    handleLiftSize(value: string): void {
      if (value === LIFT_TYPE_NO_LIFT) {
        this.setLiftAvailable(LIFT_UNAVAILABLE)
        this.setLiftType(value)
      } else {
        this.setLiftAvailable(LIFT_AVAILABLE)
        this.setLiftType(value)
      }
    }
  }
})
</script>

<style lang="css" module></style>
